(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-list"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initContinuous(root) {
      var scroller = root.querySelector('slideshow-slides');
      if (!scroller) return;

      var speed = parseFloat(root.dataset.autoplayPxPerSec) || 90;
      var paused = false;
      var lastTime = null;

      // Medir el ancho del set original ANTES de agregar los clones de relleno.
      var originalSlides = Array.prototype.slice.call(scroller.children);
      var loopWidth = scroller.scrollWidth;

      // Clones simples (div planos, sin la lógica/estilos internos del
      // componente slideshow-slide) para no pisar el 'timeline' de scroll
      // que el tema liga 1:1 a cada slide original. Solo sirven de relleno
      // visual para que el bucle se vea continuo, sin el salto de reiniciar en 0.
      originalSlides.forEach(function (node) {
        var clone = document.createElement('div');
        clone.className = 'resource-list__slide hc-loop-clone';
        clone.setAttribute('aria-hidden', 'true');
        clone.setAttribute('role', 'presentation');
        clone.innerHTML = node.innerHTML;
        scroller.appendChild(clone);
      });

      function step(timestamp) {
        if (!document.body.contains(scroller)) return;

        if (lastTime === null) lastTime = timestamp;
        var delta = (timestamp - lastTime) / 1000;
        lastTime = timestamp;

        if (!paused && loopWidth > 1) {
          var next = scroller.scrollLeft + speed * delta;
          if (next >= loopWidth) next -= loopWidth;
          scroller.scrollLeft = next;
        }

        requestAnimationFrame(step);
      }

      function pause() {
        paused = true;
      }
      function resume() {
        paused = false;
        lastTime = null;
      }

      // El arrastre del carrusel nativo captura el puntero en <slideshow-component>
      // (el ancestro), no en este scroller. Por eso 'pointerup'/'pointercancel' se
      // escuchan a nivel de documento: así SIEMPRE se detecta cuándo el usuario
      // soltó, sin importar qué elemento capture el puntero durante el arrastre.
      scroller.addEventListener('pointerdown', pause);
      scroller.addEventListener('mouseenter', pause);
      scroller.addEventListener('mouseleave', resume);
      document.addEventListener('pointerup', resume);
      document.addEventListener('pointercancel', resume);

      requestAnimationFrame(step);
    }

    function init() {
      document
        .querySelectorAll('[data-testid="collection-list"][data-autoplay-continuous="true"]')
        .forEach(initContinuous);
    }

    if (document.readyState === 'complete') {
      init();
    } else {
      window.addEventListener('load', init);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
